/**
 * Track the add to cart event.
 */
export function satelliteTrack(data) {
    if (!(data.context in TrackingContext) && data.context !== TrackingContext.productList) {
        data.context = TrackingContextTrackerMapping[rdssTracker.pageDataState.page.name] || data.context;
    }
    else if (data.context === TrackingContext.productList) {
        if (rdssTracker.pageDataState.page.name.indexOf('spirituose') > -1) {
            data.context = TrackingContext.productListSpirits;
        }
        else if (rdssTracker.pageDataState.page.name.indexOf('land') > -1) {
            data.context = TrackingContext.productListCountry;
        }
        else {
            data.context = TrackingContextTrackerMapping[rdssTracker.pageDataState.page.name] || TrackingContext.productList;
        }
    }
    _satellite.track('addToCart', {
        'addToCart': data,
    });
}
/**
 * Tracking context list.
 */
export var TrackingContext;
(function (TrackingContext) {
    TrackingContext["blank"] = "";
    TrackingContext["emotionElement"] = "emotion-element";
    TrackingContext["startpageEmotionElement"] = "startpage-emotion-element";
    TrackingContext["startpageTopTen"] = "startpage-top-ten";
    TrackingContext["startpageNew"] = "startpage-new-in-shop";
    TrackingContext["productDetail"] = "product-detail";
    TrackingContext["productDetailRecommendation"] = "product-detail-recommendations";
    TrackingContext["productList"] = "product-list";
    TrackingContext["productListSearch"] = "product-list-search";
    TrackingContext["productListNavigation"] = "product-list-navigation";
    TrackingContext["productListOffers"] = "product-list-offers";
    TrackingContext["productListPackages"] = "product-list-packages";
    TrackingContext["productListRecommendations"] = "product-list-recommendations";
    TrackingContext["productListSpirits"] = "product-list-spirits";
    TrackingContext["productListRed"] = "product-list-redwine";
    TrackingContext["productListWhite"] = "product-list-whitewine";
    TrackingContext["productListRose"] = "product-list-rosewine";
    TrackingContext["productListSparkling"] = "product-list-sparkling";
    TrackingContext["productListPresents"] = "product-list-presents";
    TrackingContext["productListAccessoir"] = "product-list-accessoir";
    TrackingContext["productListCountry"] = "product-list-country";
    TrackingContext["basketRecommendations"] = "basket-recommendations";
    TrackingContext["favoriteList"] = "favorite-list";
    TrackingContext["orderHistory"] = "order-history";
    TrackingContext["orderHistoryRepeat"] = "order-history-repeat";
})(TrackingContext || (TrackingContext = {}));
/**
 * Mapping of tracking context to the page name saved in rdssTracker.
 */
export var TrackingContextTrackerMapping;
(function (TrackingContextTrackerMapping) {
    TrackingContextTrackerMapping["wf-de:meine-empfehlungen"] = "product-list-recommendations";
    TrackingContextTrackerMapping["wf-de:rotwein"] = "product-list-redwine";
    TrackingContextTrackerMapping["wf-de:weisswein"] = "product-list-whitewine";
    TrackingContextTrackerMapping["wf-de:rosewein"] = "product-list-rosewine";
    TrackingContextTrackerMapping["wf-de:prickelndes"] = "product-list-sparkling";
    TrackingContextTrackerMapping["wf-de:angebote"] = "product-list-offers";
    TrackingContextTrackerMapping["wf-de:weinpakete"] = "product-list-packages";
    TrackingContextTrackerMapping["wf-de:geschenkideen"] = "product-list-presents";
    TrackingContextTrackerMapping["wf-de:weinzubehoer"] = "product-list-accessoir";
})(TrackingContextTrackerMapping || (TrackingContextTrackerMapping = {}));
/**
 * Disturber types displayed on the product.
 */
export var TrackingDisturberType;
(function (TrackingDisturberType) {
    TrackingDisturberType["none"] = "Kein St\u00F6rer";
    TrackingDisturberType["discount"] = "Rabatt";
})(TrackingDisturberType || (TrackingDisturberType = {}));
/**
 * Possible tracking product categories.
 */
export var TrackingCategory;
(function (TrackingCategory) {
    TrackingCategory["blank"] = "";
    TrackingCategory["offers"] = "angebote";
    TrackingCategory["all"] = "alle_weine";
    TrackingCategory["red"] = "rotwein";
    TrackingCategory["white"] = "weisswein";
    TrackingCategory["rose"] = "rosewein";
    TrackingCategory["prick"] = "prickelndes";
    TrackingCategory["packages"] = "weinpakete";
    TrackingCategory["spirit"] = "spirituosen";
    TrackingCategory["acc"] = "weinzubehoer";
    TrackingCategory["presents"] = "geschenkideen";
})(TrackingCategory || (TrackingCategory = {}));
/**
 * Mapping of category ids to category names.
 */
export var TrackingCategoryId;
(function (TrackingCategoryId) {
    TrackingCategoryId["blank"] = "0";
    TrackingCategoryId["offers"] = "336";
    TrackingCategoryId["all"] = "324";
    TrackingCategoryId["red"] = "326";
    TrackingCategoryId["white"] = "327";
    TrackingCategoryId["rose"] = "328";
    TrackingCategoryId["prick"] = "331";
    TrackingCategoryId["packages"] = "330";
    TrackingCategoryId["spirit"] = "333";
    TrackingCategoryId["acc"] = "334";
    TrackingCategoryId["presents"] = "721";
})(TrackingCategoryId || (TrackingCategoryId = {}));
/**
 * Get the category name by the category id.
 */
export function getCategoryName(category) {
    const key = Object.keys(TrackingCategoryId)[Object.values(TrackingCategoryId).indexOf(category)];
    return key ? TrackingCategory[key] : TrackingCategory.blank;
}
/**
 * Get the category id by the category name.
 */
export function getProductCategoryByCharacteristics(characteristics) {
    var _a, _b, _c;
    let category = TrackingCategory.blank;
    if ((_a = characteristics === null || characteristics === void 0 ? void 0 : characteristics.find(c => c.name === 'Prickler-Art')) === null || _a === void 0 ? void 0 : _a.value[0]) {
        category = TrackingCategory.prick;
    }
    else if ((_b = characteristics === null || characteristics === void 0 ? void 0 : characteristics.find(c => c.name === 'Spirituosen')) === null || _b === void 0 ? void 0 : _b.value[0]) {
        category = TrackingCategory.spirit;
    }
    else {
        const color = (_c = characteristics === null || characteristics === void 0 ? void 0 : characteristics.find(c => c.name === 'Farbe')) === null || _c === void 0 ? void 0 : _c.value[0];
        switch (color) {
            case 'rot':
                category = TrackingCategory.red;
                break;
            case 'weiß':
                category = TrackingCategory.white;
                break;
            case 'rosé':
                category = TrackingCategory.rose;
                break;
        }
    }
    return category;
}
/**
 * Tracking action types.
 */
export var TrackingActionType;
(function (TrackingActionType) {
    TrackingActionType["notSet"] = "not_set";
    TrackingActionType["fivePlusOne"] = "5+1";
    TrackingActionType["elevenPlusOne"] = "11+1";
})(TrackingActionType || (TrackingActionType = {}));
//# sourceMappingURL=tracking.js.map